module.exports = __webpack_public_path__ + "src/app/assets/images/moduleselection/img3.svg";